<template>
    <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="30%"
    :close-on-click-modal="false"
    :before-close="onCancel">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px" style="padding:0 10px;">
            <el-form-item label="新密码" prop="password">
                <el-input v-model="form.password" autocomplete="off" show-password placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPassword">
                <el-input v-model="form.checkPassword" autocomplete="off" show-password placeholder="确认密码"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button size="small" @click="onCancel">取 消</el-button>
            <el-button size="small" type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {userModifyPassword} from '@/api'
import {clearCache} from '@/utils'

export default {
  name:"password-form",
  props:{
    visible:{
        type:Boolean,
        default:false
    }
  },
  data(){
     const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.form.checkPassword !== '') {
            this.$refs.ruleForm.validateField('checkPassword');
          }
          callback();
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
        form:{
            password:'',
            checkPassword:'',
        },
        rules:{
            password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                { min: 8, message: '长度不低于8个字符', trigger: 'blur' },
                {validator: validatePass, trigger: 'blur'}
            ],
            checkPassword: [
                { required: true, message: '请输入确认密码', trigger: 'blur' },
                { min: 8, message: '长度不低于8个字符', trigger: 'blur' },
                {validator: validatePass2, trigger: 'blur'}
            ],
        }
    }
  },
  created(){

  },
  methods:{
    onCancel(){
        this.$emit("onHidden")
    },
    onSubmit(formName){
        this.$refs[formName].validate(async(valid) => {
            if (valid) {
                const {msg} = await userModifyPassword({password:this.form.password})
                await this.$msg.success(msg)
                clearCache('xczn_merchant_token')
                clearCache('xczn_merchant_nickname')
                clearCache('xczn_merchant_level')
                this.$router.push({path:"/login"})
                this.$emit("onHidden")
            }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/password-form/index.vue